export default "__VITE_ASSET__CygMt9wK__"